import { SagaIterator } from 'redux-saga';
import { Auth } from 'aws-amplify';
import axios, { AxiosResponse, AxiosError } from 'axios';
import { put, call, takeLatest, StrictEffect, select } from 'redux-saga/effects';
import {
  currentAction,
  currentFailedAction,
  currentSucceededAction,
  deleteCurrent,
  deleteCurrentError,
  deleteCurrentSuccess,
  logoutUserAction,
  logoutUserFailedAction,
  setIsAuthorizeAction,
  updateCurrent,
  updateCurrentError,
  updateCurrentSuccess,
  updateCurrentUserOrganizationInfo,
  updateCurrentUserOrganizationInfoSuccess,
  updateUserNotification,
  updateUserNotificationError,
  updateUserNotificationSuccess,
  acceptEulaSuccess,
  acceptEulaError,
  acceptEula,
  checkAcceptedEula,
  checkAcceptedEulaSuccess,
  checkAcceptedEulaError,
  setCopiedLinkfilterByPage,
  FireCopiedLinkfilterByPage,
  FirePutsiteUUID,
  putsiteUUID
} from './index';
import { apiInstance } from 'src/services/interceptor';
import { IUserData } from '@common/types/types';

function* currentUserWorker(): SagaIterator {
  try {
    const response: AxiosResponse = yield call(apiInstance, 'user/current');

    const userInfo = response.data;

    // const currentUserOrganizationInfo:any = localStorage.getItem('currentUserOrganizationInfo');
    // let profile_status = "client";

    // if(currentUserOrganizationInfo){
    //    const _currentUserOrganizationInfo = JSON.parse(currentUserOrganizationInfo);
    //     profile_status = _currentUserOrganizationInfo?.profile_status
    //   }
      let authorized = {
          hasOrganizations: false,
          organizationsId: "",
          role: "",
          name: "",
          // profile_status: profile_status,
          isUser : false,
          company_id: "",
          company_name: '',
          websiteCount:0
      };

  const tenantId = userInfo.tenantId;
  try { 
    const userWebsites = yield call(apiInstance.post , 'reporttool/usermanagement/website/get-all-websites')
    if ( userWebsites?.data?.data?.length) {
      authorized = { ...authorized , websiteCount: userWebsites?.data?.data?.length }
    }
  }catch{}
  
  // try{
  //     const organisationResponse = yield call(apiInstance.post, `reporttool/organisationlevel/organisation/get-user-organizations`, { tenantId });      
    
  //     if (organisationResponse?.data?.length > 0) {
  //         for (const data of organisationResponse.data) {            
  //             if (data?.tenant_id === tenantId) {
  //                 authorized = {...authorized,
  //                     hasOrganizations: true,
  //                     organizationsId: data.id,
  //                     role: data.role,
  //                     name: data.name,
  //                     company_id : data?.company_id
  //                 };
  //                 break;
  //             }
  //             // authorized = {...authorized,
  //             //   isUser:true
  //             // };
  //             // if(authorized.hasOrganizations && authorized.isUser ){
  //             //     break;
  //             // }
  //         }
    
  //     }

  // } catch (error :any) {
  // }
  try { 
    // get the current user company id
    const companyDetails = yield call(apiInstance.post , `reporttool/organisationlevel/company/details/get` , { tenantId })
    if ( companyDetails ) {
        authorized = {...authorized,
          company_id : companyDetails?.data?.id,
          company_name: companyDetails?.data?.company_name
        };
    }
  }catch {

  } 
  const data:IUserData = {
    ...authorized,
    ...userInfo,
  }  
  localStorage.setItem('currentUserOrganizationInfo',JSON.stringify(authorized));

  yield put(currentSucceededAction({ data }));


  } catch (error) {
    if (error instanceof AxiosError) {
      console.log(error.message);
      yield put(currentFailedAction(error.message));
    }
  }
}

function* logoutUserWorker(): SagaIterator {
  try {
      // localStorage.removeItem('currentUserOrganizationInfo');
    yield call([Auth, 'signOut']);
    yield put(setIsAuthorizeAction(false));
  } catch (error) {
    if (error instanceof AxiosError) {
      yield put(logoutUserFailedAction);
    }
  }
}

function* updateCurrentUser({ payload: { data, successMessage } }: any): SagaIterator {
  try {
    const response: AxiosResponse = yield call(apiInstance.put, 'user/current', data);
    const responseData: IUserData = response.data;
    successMessage && successMessage();
    yield put(updateCurrentSuccess({ data: responseData }));
  } catch (error) {
    if (error instanceof AxiosError) {
      yield put(updateCurrentError(error.message));
    }
  }
}

function* deletCurrentUser({payload: {successMessage}}: any): SagaIterator {
  try {
    const response: AxiosResponse = yield call(apiInstance.delete, 'user/current');
    successMessage && successMessage();
    yield put(deleteCurrentSuccess(response.data));
  } catch (error) {
    if (error instanceof AxiosError) {
      yield put(deleteCurrentError(error.message));
    }
  }
}

function* updateCurrentUserOrganizationInfoWorker({payload: {data}}: any): SagaIterator {
  try {

    // let permissions: any = [];

    // if(data.profile_status == "user"){
    //   try{
    //     const {tenantId, userSelectedOrganization} = yield select((state) => state.user.data);
    //     const currentUserOrganizationInfo:any = localStorage.getItem('currentUserOrganizationInfo');
    //     const _currentUserOrganizationInfo = JSON.parse(currentUserOrganizationInfo);
    //     const _userSelectedOrganization =  userSelectedOrganization ? userSelectedOrganization : _currentUserOrganizationInfo.userSelectedOrganization
                 
    //     const permissionsResults = yield call(apiInstance.post, `reporttool/organisationlevel/organisation/get-user-permissions`, { organizationId:_userSelectedOrganization,userTenantId:tenantId });

    //     if(permissionsResults.data){
    //       permissions = permissionsResults.data
    //     }
        
    //   } catch (error: any) {}
    // }    
    // data.userPermission = permissions;

    localStorage.setItem('currentUserOrganizationInfo', JSON.stringify(data));
    yield put(currentSucceededAction({ data }));
  } catch (error) {
   
  }
}

function* updateUserIsnotificationAllowed({payload: {  tenantId, isEmailNotificationsEnabled  }}: any): SagaIterator {
  try {
    const notification = yield call(apiInstance.put, `reporttool/notification`, {
        tenantId : tenantId ,
        isEmailNotificationsEnabled : isEmailNotificationsEnabled
      });

    if(notification?.data?.statusCode == 200 ){
      yield put( updateUserNotificationSuccess(notification?.data?.body))
      return;
    }
    yield put(updateUserNotificationError());

  } catch (error: any) {
    const errorMessage = error.response.data || error.response?.data?.message || 'error'
    yield put(updateUserNotificationError());
  }
}


function* acceptEulaCall({payload: {  tenantId  }}: any): SagaIterator {
  try {
      if( !tenantId ){
          throw new Error("tenantId not specified");
      }
      
      const response = yield call(apiInstance.post, `reporttool/organisationlevel/global/eula/edit`, {
            "tenantId": tenantId,
            "accepted": true
        });
      if(response.status != 200){
          throw new Error("Faild to accept EULA");
      }
      yield put(acceptEulaSuccess(true)); 
  } catch (error: any) {
      const errorMessage = error.response?.data?.message ?? 'error';
      
      yield put(acceptEulaError(errorMessage));
  }
}



function* checkAcceptedEulaCall({payload: {  tenantId  }}: any): SagaIterator {
  try {
      if( !tenantId ){
          throw new Error("tenantId not specified");
      }
      
      const response = yield call(apiInstance.post, `reporttool/organisationlevel/global/eula/check`, {
            "tenantId": tenantId,
        });
      if(response.status != 200){
          throw new Error("Faild to accept EULA");
      }
      yield put(checkAcceptedEulaSuccess(response.data.pass)); 

  } catch (error: any) {
      const errorMessage = error.response?.data?.message ?? 'error';
      
      yield put(checkAcceptedEulaError(errorMessage));
  }
}


function* setCopiedLinkfilterByPageCall({payload}: any): SagaIterator {
  try {
    
      if( !payload ){
          throw new Error("link not specified");
      }
    
      yield put(setCopiedLinkfilterByPage(payload)); 

  } catch (error: any) {
    console.log(error);
        
  }
}


function* FirePutsiteUUIDCall({payload}: any): SagaIterator {
  try {
    
      if( !payload ){
          throw new Error("link not specified");
      }
    
      yield put(putsiteUUID(payload)); 

  } catch (error: any) {
    console.log(error);
        
  }
}

function* currentUserRootSaga(): Generator<StrictEffect, void> {
  yield takeLatest(currentAction.type, currentUserWorker);
  yield takeLatest(logoutUserAction.type, logoutUserWorker);
  yield takeLatest(updateCurrent.type, updateCurrentUser);
  yield takeLatest(deleteCurrent.type, deletCurrentUser);
  yield takeLatest(updateCurrentUserOrganizationInfo.type, updateCurrentUserOrganizationInfoWorker);
  yield takeLatest(updateUserNotification.type, updateUserIsnotificationAllowed);
  yield takeLatest(acceptEula.type, acceptEulaCall);
  yield takeLatest(checkAcceptedEula.type, checkAcceptedEulaCall);
  yield takeLatest(FireCopiedLinkfilterByPage.type, setCopiedLinkfilterByPageCall);
  yield takeLatest(FirePutsiteUUID.type, FirePutsiteUUIDCall);


}

export { currentUserRootSaga };